export const AwakenedKingdomAddress = '0x8a0594343fea49bDC295D2dE55EA1A60e261ab16'
